export const DURATION_OPTIONS = [5, 10] as const;
export const DEFAULT_RANGES = [10, 20, 30, 50, 100] as const;